import { pipe } from 'ramda'
import { connect } from 'react-redux'
import { LicenseInstallerActions } from '../../store'
import mapStateToProps from './licenseInstallerModal.selector'
import LicenseInstallerModal from './licenseInstallerModal'
import { LicensesActions } from '../../../Licenses/store'
import { withLDConsumer } from 'launchdarkly-react-client-sdk'

const mapDispatchToProps = dispatch => ({
  saveBundle: (isActiveLinceseBundleV2) => dispatch(LicenseInstallerActions.saveBundle(isActiveLinceseBundleV2)),
  scheduleBundle: () => dispatch(LicenseInstallerActions.scheduleBundle()),
  resetLicenseInstaller: () => dispatch(LicenseInstallerActions.reset()),
  handleBack: () => dispatch(LicenseInstallerActions.back()),
  refreshLicenses: () => dispatch(LicensesActions.getLicenses()),
  refreshLicenseBundles: () => dispatch(LicensesActions.getLicenseBundles()),
  setInstallNowScheduleType: () => dispatch(LicenseInstallerActions.updateScheduleType(1))
})

export default pipe(
  connect(mapStateToProps, mapDispatchToProps),
  withLDConsumer()
)(LicenseInstallerModal)
